(function () {
    'use strict';

    angular.module('swif.parcauto')
    .config(['$routeProvider', 'swifParcautoConstant', function($routeProvider, constant) {
        $routeProvider.when(constant.automobile.routes.table_view, {
            templateUrl: 'partials/parcauto/automobile_table_view.html',
            controller: 'ParcAutoAutomobilesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when(constant.automobile.routes.explorer_view, {
            templateUrl: 'partials/parcauto/automobile_explorer_view.html',
            controller: 'ParcAutoAutomobilesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }])

    .controller('ParcAutoAutomobilesController', [
        '$scope', '$location', 'swifFrameworkService','swifInterventionsService', 'swifParcautoService',
        function ($scope, $location, swif, moduleInter, moduleParcAuto) {
            console.log('init ParcAutoAutomobilesController');
            $scope.filters = {};
            $scope.add_consumable = {};
            swif.settings.page.title = 'Parc auto - Interventions';
            swif.message.addOnErrorHandler($scope);
            $scope.debug = $location.search().debug;
            $scope.loading = {tasks: {}};

            moduleParcAuto.automobile.createCollection()
            .then(function (collection) {
                $scope.automobiles = collection;
                if (collection.currentItem) {
                    $scope.setCurrentItem(collection.currentItem);
                }
            });

            //$scope.preValidate = moduleParcAuto.automobile.preValidate;

            $scope.callback = function (error, data) {
                $scope.automobiles.defaultActionCallback(error, data);
            };
            $scope.setCurrentItem = function (automobile) {
                var isCurrent = false;
                $scope.equipment_lines = [];
                if ($scope.automobiles.currentItem) {
                    if ($scope.automobiles.currentItem.id === automobile.id) {
                        isCurrent = true;
                    }
                }
                $scope.automobiles.setCurrent(automobile.id);
                if (automobile.maintenance_service_ids) {
                    $scope.maintenance_service_ids = automobile.maintenance_service_ids;
                } else {
                    delete $scope.maintenance_service_ids;
                }
                //get list of open interventions
                if (automobile.equipment_id) {
                    moduleParcAuto.automobile.getInterventionsSummary(automobile)
                    .then(function (summary) {
                        $scope.intervention_summary = summary;
                    });
                    moduleParcAuto.automobile.getDoneTasks(automobile)
                    .then(function (tasks) {
                        $scope.done_tasks = tasks;
                    });
                    if (automobile.consumable_ids) {
                        moduleParcAuto.automobile.getConsumablesByType(automobile)
                        .then(function (consumables_by_type) {
                            $scope.consumables_by_type = consumables_by_type;
                        });
                    }
                    $scope.getEquipmentLines(automobile);
                }
            };
            $scope.getConsumablesByType = function (type) {
                if (type.consumables) {
                    delete type.consumables;
                } else {
                    var filter = {};
                    var consumable_ids = $scope.automobiles.currentItem.consumable_ids;
                    swif.data.addFilter(filter, 'type_id', '=', type.type_id[0]);
                    swif.data.addFilter(filter, 'id', 'in', consumable_ids);
                    swif.data.get('consumable', undefined, filter)
                    .then(function (consumables) {
                        type.consumables = consumables;
                    });
                }
            };
            $scope.$watch('add_consumable.type_id', function (newV) {
                if (newV) {
                    $scope.filters.consumable = {};
                    swif.data.addFilter($scope.filters.consumable, 'type_id', '=', newV[0]);
                }
            });
            $scope.dispatchAddConsumable = function () {
                var id = $scope.add_consumable.consumable_id;
                var copy = {
                    id: $scope.automobiles.currentItem.id,
                    consumable_ids: $scope.automobiles.currentItem.consumable_ids || []
                };
                if (copy.consumable_ids.indexOf(id[0]) === -1) {
                    copy.consumable_ids.push(id[0]);
                }
                swif.data.save('parcauto_automobile', copy.id, copy)
                .then(function (data) {
                    if (data.result) {
                        $scope.automobiles.currentItem.consumable_ids = copy.consumable_ids;
                    }
                });
            };
            $scope.removeConsumable = function (consumable) {
                var consumable_ids = $scope.automobiles.currentItem.consumable_ids;
                var index = consumable_ids.indexOf(consumable.id);
                if (index !== -1) {
                    consumable_ids.splice(index, 1);
                }
                var copy = {
                    id: $scope.automobiles.currentItem.id,
                    consumable_ids: consumable_ids
                };
                swif.data.save('parcauto_automobile', copy.id, copy);
            };
            $scope.getEquipmentLines = function (automobile) {
                var filter = {};
                swif.data.sortOn(filter, 'km', 'ASC');
                swif.data.addFilter(filter, 'equipment_id', '=', automobile.equipment_id[0]);
                swif.data.addFilter(filter, 'oil_qtity', '!=', false);
                swif.data.get('equipment_line', undefined, filter)
                .then(function (equipment_lines) {
                    $scope.equipment_lines = equipment_lines;
                });
            };
        }
    ])

    .controller('ParcAutoAutomobileController', [
        '$scope', '$location', 'swifFrameworkService',
        function ($scope, $location, swif) {
            console.log('init ParcAutoAutomobileController');
            swif.message.addOnErrorHandler($scope);
            $scope.modules = swif.module.modules;
            $scope.debug = $location.search().debug;
            $scope.filters = {
                equipment: {}
            };
            if (!$scope.model.equipment_id) {
                $scope.attach_equipment = true;
            }
            swif.data.addFilter($scope.filters.equipment, 'categ_id.is_vehicle', '=', true);
            var syncEquipment = function (id) {
                swif.data.get('equipment', id).then(function (equipment) {
                    _.forOwn(equipment, function (value, key) {
                        if (key === 'id') {
                            return;
                        }
                        $scope.model[key] = value;
                    });
                });
            };
            $scope.$watch('create_equipment', function (newV, oldV) {
                if (newV === oldV) {
                    return;
                }
                if (newV === false) {
                    $scope.attach_equipment = true;
                } else if (newV === true) {
                    $scope.attach_equipment = false;
                }
            });
            $scope.$watch('attach_equipment', function (newV, oldV) {
                if (newV === oldV) {
                    return;
                }
                if (newV === true) {
                    $scope.create_equipment = false;
                } else if (newV === false) {
                    if (!$scope.model.equipment_id) {
                        $scope.create_equipment = true;
                    } else {
                        $scope.model.equipment_id = false;
                        $scope.create_equipment = true;
                    }
                }
            });
            $scope.$watch('model.equipment_id', function (newV) {
                if (!newV) {
                    return;
                }
                syncEquipment(newV[0]);
            });
            $scope.$watch('model.brand_id', function (newV) {
                $scope.filters.model = {};
                if (newV) {
                    swif.data.addFilter($scope.filters.model, 'brand_id', '=', newV[0]);
                }
            });
            $scope.$watch('model.model_id', function (newV) {
                if (newV) {
                    swif.data.get('parcauto_model', newV[0])
                    .then(function (data) {
                        $scope.model.brand_id = data.brand_id;
                    });
                }
            });
        }
    ]);
})();
